<template>
    <div class="navbar navbar-expand-lg navbar-light"  v-if="currentRoute.path !== '/login'">
        <div class="text-center d-lg-none w-100">
            <button type="button" class="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-footer">
                <i class="icon-unfold mr-2"></i>
                Footer
            </button>
        </div>

        <div class="navbar-collapse collapse" id="navbar-footer">
            <span class="navbar-text">
                © 2019 - 2020. <a href="javascript:void(0)">Line Bank Ums project</a>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "layout-footer"
    }
</script>

<style scoped>

</style>
